'use client'

import * as React from 'react'
import { Separator } from "@sarkiai/ui"
import { useTranslations } from "@/components/I18nProvider"
import { GlassBox } from "@/components/custom/box"
import { FileText } from "lucide-react"

const CGU_SECTIONS_COUNT = 9

export default function CGUPage() {
  const t = useTranslations('cgu')
  const tCommon = useTranslations()

  const sections = React.useMemo(() => {
    return Array.from({ length: CGU_SECTIONS_COUNT }, (_, i) => ({
      id: `cgu-section-${i + 1}`,
      title: t(`title${i + 1}`),
      content: t(`content${i + 1}`),
    }))
  }, [t])

  return (
    <main className="flex min-h-screen flex-col bg-background">
      {/* Hero Section */}
      <section className="relative py-24 md:py-32 bg-black text-white overflow-hidden text-center px-4 lg:px-12">
        <div className="absolute inset-0 bg-white/5 opacity-50" />
        <div className="container relative z-10 mx-auto">
          <div className="max-w-4xl mx-auto space-y-8">
            <div className="inline-flex items-center justify-center h-20 w-20 rounded-3xl bg-white/10 mb-4 backdrop-blur-xl shadow-2xl">
              <FileText className="h-10 w-10 text-white" />
            </div>
            <h1 className="text-4xl md:text-8xl  tracking-tighter uppercase leading-none">
              {tCommon('footer.cgu')}
            </h1>
            <p className="text-xl md:text-2xl opacity-70 max-w-2xl mx-auto leading-relaxed">
              {tCommon('account.settings.about_items.terms_of_service')}
            </p>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2" />
      </section>

      <section className="py-20 md:py-32 px-4 lg:px-12">
        <div className="container mx-auto max-w-5xl">
          <GlassBox className="p-10 md:p-20 space-y-16 rounded-4xl border-black/5 dark:border-white/10 shadow-2xl shadow-black/5 bg-white/50 dark:bg-card/50 backdrop-blur-2xl text-foreground/80">
            {sections.map((section, index) => (
              <React.Fragment key={section.id}>
                <section className="space-y-6">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-xl bg-black dark:bg-white text-white dark:text-black flex items-center justify-center  shrink-0">
                      {(index + 1).toString().padStart(2, '0')}
                    </div>
                    <h2 className="text-2xl  uppercase tracking-tight text-foreground">{section.title}</h2>
                  </div>
                  <p className="leading-relaxed whitespace-pre-line pl-14">
                    {section.content}
                  </p>
                </section>
                {index < sections.length - 1 && <Separator className="bg-black/5 dark:bg-white/10 h-[1px]" />}
              </React.Fragment>
            ))}
          </GlassBox>
        </div>
      </section>
    </main>
  )
}
